import request from '@/utils/request'

export const getOrderTypes = (params) => {
  return request({
    url: '/api/order-types',
    method: 'get',
    params
  })
}

export const createOrderType = (data) => {
  return request({
    url: '/api/order-types',
    method: 'post',
    data
  })
}

export const updateOrderType = (id, data) => {
  return request({
    url: `/api/order-types/${id}`,
    method: 'put',
    data
  })
}

export const deleteOrderType = (id) => {
  return request({
    url: `/api/order-types/${id}`,
    method: 'delete'
  })
}

export const toggleOrderTypeStatus = (id, data) => {
  return request({
    url: `/api/order-types/${id}/status`,
    method: 'patch',
    data
  })
}

export const getOrderTypeHierarchy = () => {
  return request({
    url: '/api/order-types/hierarchy',
    method: 'get'
  })
}